'use strict';

var _themeCurrency = require('@shopify/theme-currency');

// Manage Elements and Targets
var cartIndicator = document.querySelector('#cart-indicator');
var flyoutContainer = document.querySelector('#cart-flyout');
var flyoutProducts = document.querySelector('.cart-flyout__products');
var flyoutTotal = document.querySelector('.cart-flyout__total');
var addButton = document.querySelector('.product-form__cart-submit');

// Methods
var methods = {

  cartHasProducts: false,

  getCart: function getCart() {
    return fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin'
    }).then(function (response) {
      return response.json();
    }).then(function (cart) {
      if (cart.item_count > 0) {
        methods.cartHasProducts = true;
        // If there are items, add them to the flyout
        methods.populateFlyout(cart);
      }
    });
  },

  populateFlyout: function populateFlyout(cart) {
    flyoutProducts.innerHTML = "";
    flyoutTotal.innerHTML = "";
    var cartItemMarkup = function cartItemMarkup(cartItem) {
      return '\n      <div class="cart-flyout-product">\n        <div class="cart-flyout-product__image"><img src="' + cartItem.image + '" alt="Image of ' + cartItem.title + '" /></div>\n          <div class="cart-flyout-product__text">\n          <p class="mb-1 text-body">' + cartItem.title + '</p>\n          <p class="text-heading-small my-1">Qty: ' + cartItem.quantity + ' | ' + (0, _themeCurrency.formatMoney)(cartItem.final_line_price) + '</p>\n        </div>\n      </div>';
    };
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = cart.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var cartItem = _step.value;

        if (cartItem.image == null) {
          // This path had to be hardcoded as JS has no access to asset url methods in liquid :(
          cartItem.image = '//cdn.shopify.com/s/files/1/0064/5342/8271/files/placeholder_image_300x.png?v=1557207672';
        }
        // Template Literal for Items
        // New Container for each Item
        var cartItemContainer = document.createElement("div");
        // Set content of created element to be template literal
        cartItemContainer.innerHTML = cartItemMarkup(cartItem);
        // Add to products container in flyout
        flyoutProducts.appendChild(cartItemContainer);
        methods.showCartFlyout();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  },
  flyoutIsInHover: function flyoutIsInHover() {},
  hideCartFlyout: function hideCartFlyout() {
    flyoutContainer.classList.remove('visible');
  },

  showCartFlyout: function showCartFlyout() {
    // Clear Flyout contents to ensure no duplication
    flyoutContainer.classList.add('visible');
  }

  // Click event for POC
};cartIndicator.addEventListener('mouseenter', function (event) {
  methods.getCart();
});

cartIndicator.parentElement.addEventListener('mouseout', function (event) {
  methods.hideCartFlyout();
});

if (addButton) {
  addButton.addEventListener('click', function (event) {
    setTimeout(function () {
      methods.getCart();
      setTimeout(function () {
        return methods.hideCartFlyout();
      }, 4000);
    }, 1000);
  });
}